// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\reset-password.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\reset-password.tsx");
  import.meta.hot.lastModified = "1759761980446.823";
}
// REMIX HMR END

import ResetPassword from '~/components/auth/ResetPassword';
import { PublicRoute } from "~/components/RouteProtection";
export const meta = () => {
  return [{
    title: 'Reset Password - Nomadic Studios'
  }, {
    name: 'description',
    content: 'Reset your password for Nomadic Studios'
  }];
};
export default function ResetPasswordPage() {
  return <PublicRoute>
      <ResetPassword />
    </PublicRoute>;
}
_c = ResetPasswordPage;
var _c;
$RefreshReg$(_c, "ResetPasswordPage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;